export const features = [
  {
    title: 'Sem mensalidades',
    description: 'Você paga apenas pelo frete que usar, sem taxas escondidas.',
    icon: 'Smartphone',
  },
  {
    title: 'Frete com desconto',
    description: 'PAC e SEDEX para todo o Brasil por menos que no balcão dos Correios.',
    icon: 'Percent',
  },
  {
    title: 'Tudo em um só lugar',
    description: 'Do cálculo à etiqueta, com o histórico dos seus envios e a sua carteira.',
    icon: 'Package',
  },
  {
    title: 'Atendimento pronto para ajudar',
    description: 'Ficou com alguma dúvida? Fale com a gente pelo e-mail de suporte.',
    icon: 'Headphones',
  },
];

export const howItWorks = [
  {
    step: '1º',
    title: 'Crie sua conta',
    description: 'Cadastro rápido com CPF ou CNPJ, sem burocracia.',
    icon: 'UserPlus',
  },
  {
    step: '2º',
    title: 'Calcule e emita seu frete com desconto',
    description: 'Compare PAC e SEDEX e gere a etiqueta na hora.',
    icon: 'Calculator',
  },
  {
    step: '3º',
    title: 'Acompanhe suas entregas',
    description: 'Veja o histórico e o rastreio dos seus envios.',
    icon: 'TrendingUp',
  },
];

export const faqs = [
  {
    question: "Existe algum custo na plataforma In'Nova Envios?",
    answer: 'Não há mensalidade nem taxa para criar a conta. Você paga somente pelo frete de cada envio que emitir.',
  },
  {
    question: "Preciso ter CNPJ para usar a In'Nova Envios?",
    answer: 'Não. Você pode se cadastrar com CPF ou CNPJ.',
  },
  {
    question: 'Quais serviços de envio estão disponíveis?',
    answer: 'Você emite envios pelos Correios, nos serviços PAC e SEDEX, com desconto sobre o preço de balcão.',
  },
  {
    question: 'Como é feito o pagamento?',
    answer: 'O pagamento é feito pela sua carteira na plataforma: você adiciona saldo e o valor do frete é debitado quando emite a etiqueta.',
  },
  {
    question: 'Como funciona depois de emitir o envio?',
    answer: 'Você imprime a etiqueta gerada pela plataforma, cola na embalagem e leva o pacote a uma agência dos Correios. O código de rastreio fica disponível em Meus envios.',
  },
  {
    question: 'Existe bônus para quem está começando?',
    answer: 'Sim: você ganha R$ 5 na carteira ao emitir o seu primeiro envio, uma vez por CPF ou CNPJ. Se esse envio for cancelado, o bônus é retirado.',
  },
  {
    question: 'O que posso e o que não posso enviar?',
    answer: 'Não podem ser enviados, por exemplo, explosivos, inflamáveis, gases sob pressão, perecíveis, drogas, dinheiro e armas. Alguns itens, como líquidos e eletrônicos com bateria, têm regras de embalagem. Veja a lista completa na página "O que pode enviar".',
  },
  {
    question: 'Posso cancelar um envio?',
    answer: 'Sim, enquanto o envio ainda estiver aguardando postagem. O valor volta para a sua carteira.',
  },
  {
    question: 'Como é calculado o frete?',
    answer: 'O valor considera o CEP de origem e de destino, o peso e as dimensões do pacote. Quando o volume é grande, os Correios cobram o peso cubado (dimensões) se ele for maior que o peso real.',
  },
];

